import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Footer.css";
const Footer = () => {
  return (
    <>
      <section className="Footer">
        <div className="container-fluid">
          <div className="footer_img_holder">
            <img
              src="/assets/images/home/footer/footer-img.png"
              alt="footer-img"
              className="footer_img"
            />
          </div>

          <div className="footer_content_holder">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="col_content_holder">
                  <h4 className="col_title">About Platform</h4>
                  <div className="col_text_holder">
                    <p className="col_text">
                      Audio Meet is a complete audio conversation ecosystem with
                      mobile apps for users & hosts, a web host interface, & a
                      powerful admin panel built for seamless, real-time
                      communication.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-3 col-sm-6 mb-3">
                <h4 className="col_title">Our Products</h4>

                <div className="col_text_holder">
                  <p className="col_text"> User Mobile App </p>
                  <p className="col_text">Host App & Web Panel</p>
                  <p className="col_text">Admin Dashboard</p>
                  <p className="col_text">Audio Room Management System</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-3 col-sm-6 mb-3 ">
                <h4 className="col_title">Contact Us</h4>
                <div className="col_text_holder">
                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "ffffff" }}
                    />
                    <p className="contact_text">+91 90000 12345</p>
                  </div>

                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#ffffff" }}
                    />
                    <p className="contact_text">support@audiomeet.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="container">
            <div className="footer_links_holder">
              <div className="footer_links">
                {[
                  { icon: faInstagram, link: "https://www.instagram.com" },
                  { icon: faFacebookF, link: "https://www.facebook.com" },
                  { icon: faYoutube, link: "https://www.youtube.com" },
                  { icon: faXTwitter, link: "https://www.twitter.com" },
                  { icon: faLinkedinIn, link: "https://www.linkedin.com" },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={item.icon}
                      style={{ color: "ffffff", fontSize: "20px" }}
                    />
                  </a>
                ))}
              </div>

              {/* <div className="footer_text_div">
                <p className="footer_text">
                  Copyright ©2026 All Rights Reserved. Developed by
                  <a
                    href="https://profcymaglobal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link_text"
                  >
                    Profcyma
                  </a>
                </p>
              </div> */}

              <div className="footer_text_div">
                <p className="footer_text">
                  Copyright ©2026  All Rights Reserved. Developed by
                  <a
                    href="https://profcymaglobal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link_text"
                  >  {""}
                    Profcyma
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
